const apiAuthorization = {
    ga: {
        redirect(idToken, tmpKey) {
            location.href = `${process.env.VUE_APP_APIURL}/authorization/ga?idToken=${idToken}&tmpKey=${tmpKey}`;
        }
    },

    gsc: {
        redirect(idToken, tmpKey) {
            location.href = `${process.env.VUE_APP_APIURL}/authorization/gsc?idToken=${idToken}&tmpKey=${tmpKey}`;
        }
    }
};

export default apiAuthorization;
